import { useEffect, useRef, useState } from 'react';

export const useNavbarScrolled = () => {
	const [isScrolled, setIsScrolled] = useState(false);
	const navRef = useRef<HTMLElement | null>(null);

	useEffect(() => {
		const handleScroll = () => {
			if (navRef.current) {
				const navHeight = navRef?.current?.offsetHeight;
				if (window.scrollY >= navHeight) {
					setIsScrolled(true);
				} else {
					setIsScrolled(false);
				}
			}
		};

		window.addEventListener('scroll', handleScroll);

		return () => {
			window.removeEventListener('scroll', handleScroll);
		};
	}, []);

	return { isScrolled, navRef };
};
